import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, logo, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          justifyBetween
        >
          <CFView w="100%" textCenter mt="3%">
            <CFImage
              w="75%"
              maxWidth="500px"
              src={logo}
              alt="Haku Sushi hero text"
              zIndex={98}
            />
          </CFView>
          <CFView textCenter column center mb="8%" w="100%">
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          center
          textCenter
          relative
        >
          <CFImage
            h="100vh"
            maxHeight="700px"
            src={heroText}
            alt="Haku Sushi hero text"
            zIndex={98}
          />
          <CFView pulsate zIndex={99} absolute bottom="20px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
